/**
 * @generated SignedSource<<0012349949178340de24ab43f0a1741a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionTagInputForCompetitionEditPageFragment$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly name: string;
    };
  }>;
  readonly " $fragmentType": "CompetitionTagInputForCompetitionEditPageFragment";
};
export type CompetitionTagInputForCompetitionEditPageFragment$key = {
  readonly " $data"?: CompetitionTagInputForCompetitionEditPageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionTagInputForCompetitionEditPageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionTagInputForCompetitionEditPageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TagEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Tag",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "CompetitionTagConnection",
  "abstractKey": null
};

(node as any).hash = "d6d97f1ad664c5bdea721e7e0c4dbea8";

export default node;
